import apiClient from './api'
import type { AIResponseSuggestions, AIClassification } from '../types'

export const aiService = {
  // Generate AI response suggestions
  async generateResponses(threadId: string, messageId: string): Promise<AIResponseSuggestions> {
    const response = await apiClient.post(`/ai-email/suggest/${threadId}/${messageId}`)
    return response.data.suggestions
  },

  // Classify email
  async classifyEmail(emailBody: string, subject: string): Promise<AIClassification> {
    const response = await apiClient.post('/ai-email/classify', {
      body: emailBody,
      subject: subject
    })
    return response.data
  },

  // Extract lead information
  async extractLeadInfo(emailBody: string, subject: string) {
    const response = await apiClient.post('/ai-email/extract-lead', {
      body: emailBody,
      subject: subject
    })
    return response.data
  },

  // Create lead from email
  async createLeadFromEmail(threadId: string) {
    const response = await apiClient.post(`/ai-email/create-lead/${threadId}`)
    return response.data
  },

  // Create appointment from email
  async createAppointmentFromEmail(threadId: string) {
    const response = await apiClient.post(`/ai-email/create-appointment/${threadId}`)
    return response.data
  },

  // Link email to customer
  async linkToCustomer(threadId: string, customerId: string) {
    const response = await apiClient.post(`/ai-email/link-customer/${threadId}`, { customerId })
    return response.data
  },

  // Link email to job
  async linkToJob(threadId: string, jobId: string) {
    const response = await apiClient.post(`/ai-email/link-job/${threadId}`, { jobId })
    return response.data
  },
}

export default aiService

